import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';
import { apiClientV2 } from '~/api/client';
import { Creator } from '~/clientApi/creator.model';

import { CountriesEntity, LabelValuePair } from './useGetIGInsights';

export const useGetTTInsights = ({ id }: { id?: string }) => {
  const router = useRouter();

  return useQuery({
    queryKey: ['insights-tiktok', { id }],
    queryFn: () => {
      if (router.asPath.includes('/media-kits/')) {
        // GET data using SSR Token for media kits
        return axios
          .get<TTInsights>(`/api/insights/${id}/tt`)
          .then((r) => r.data);
      }

      return apiClientV2
        .get<TTInsights>(`/creator-tiktok-insights/${id}`)
        .then((r) => r.data);
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export interface TTInsights {
  id: string;
  countries?: CountriesEntity[];
  genders?: LabelValuePair[];
  ages?: LabelValuePair[];
  locales?: null[] | null;
  creator: Partial<Creator>;
  createdAt: string;
  updatedAt: string;
  agesShort?: LabelValuePair[];
  createdAtAgo: string;
  updatedAtAgo: string;
  demographicsLastUpdatedAt: string;
  demographicsSource?: string;
}
